import * as React from 'react';
export const lyftSvg = React.forwardRef(function lyftSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FF00BF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.512 17.659V8.293H4v8.78c0 2.413 1.593 3.512 3.073 3.512a3.048 3.048 0 0 0 1.28-.286c.058-.027.152-.086.152-.086s-.09-.093-.126-.135c-.562-.639-.867-1.47-.867-2.42ZM28 15.317v-3.512h-1.253c-.524-2.76-3.425-4.573-6.341-3.484-1.624.607-2.943 2.548-2.943 4.282v7.979h.153a3.494 3.494 0 0 0 2.38-1.077c.63-.653.98-1.525.98-2.432h1.463v-3.512h-1.463v-.965c0-.375.198-.726.526-.909.9-.499 1.815.144 1.815.996v3.22c0 1.274.48 2.456 1.354 3.329a4.666 4.666 0 0 0 3.178 1.351H28v-3.51a1.168 1.168 0 0 1-1.17-1.17v-.586H28Zm-14.927-3.512v4.683a.584.584 0 0 1-1 .414.585.585 0 0 1-.17-.414v-4.683H8.39v5.854a2.929 2.929 0 0 0 4.83 2.224c-.055.432-.294.792-.69 1.04-.373.233-.857.356-1.402.357-.56 0-1.131-.133-1.65-.382 0 0-.093-.044-.21-.111v3.12a6.651 6.651 0 0 0 2.468.484c1.312 0 2.51-.41 3.371-1.156.967-.836 1.479-2.056 1.479-3.528v-7.902h-3.513Z',
      fill: '#fff',
    }),
  );
});
lyftSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var lyft = {
  category: 'brand',
  colorable: false,
  name: 'lyft',
  svg: lyftSvg,
};
